module.exports = __webpack_public_path__ + "static/media/pexels-photo-58639.15df0931.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/components/common/app2soft/images/005_mo/pexels-photo-58639.jpeg
// module id = 775
// module chunks = 0